<template>
    <div id="componente-listado-auditoria-contratos">
      <v-container
      fluid class="bkground">
      <v-card flat>
        <v-card-title>
          <span></span>
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <MainAuditoriaContratos/>
      </v-card>
      </v-container>
    </div>
</template>
<script>
import MainAuditoriaContratos from '@/views/administracion/auditorias/auditoria/contratos/Default.vue';

export default {
  name: 'ComponenteListadoAuditoriaContratos',
  components: {
    MainAuditoriaContratos,
  },
  methods: {
    cerrar() {
      this.$emit('cerrarVentanaAuditoriaContratos');
    },
  },
};
</script>
